import { render, staticRenderFns } from "./Scb.vue?vue&type=template&id=53638be2"
import script from "./Scb.vue?vue&type=script&lang=js"
export * from "./Scb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports